<script setup>
import CustomButton from "@/components/Button/Button.vue";
import {useRouter} from "vue-router";
import {useBlogStore} from "@/stores/blogStore.js";

const router = useRouter();
const blogStore = useBlogStore();

defineProps({

  destination: {
    type: Object,
    required: true
  },
  index: {
    type: Number,
    required:true
  }
});


</script>
<template>

  <div :class="['max-w-6xl mx-auto flex flex-col md:flex-row items-center md:items-start gap-17', index % 2 !== 0 ? 'md:flex-row-reverse' : '']">

    <div class="w-full flex justify-center overflow-hidden ">
      <img
          :src="destination.image"
          alt="About Image"
          class="w-full max-w-[350px] sm:max-w-[500px] h-auto object-contain duration-500 hover:scale-105"
      />
    </div>

    <div class="w-full flex justify-center md:justify-start">
      <div class="w-full max-w-[350px] sm:max-w-[500px] text-left space-y-7.5">
        <hr class="w-1/4 h-0.5 bg-primary-violet border-0">
        <p class="responsive-title-2 font-thin text-primary-darkBlue" v-html="destination.title"></p>
        <p class="responsive-body-large text-bw-midGrey" v-html="destination.description"></p>
          <div class="mt-6 flex space-x-6">
            <CustomButton
                type="red"
                size="medium"
                class="py-2 px-4"
                @click="router.push('/yachts')"
            >
              SEARCH YACHTS
            </CustomButton>
            <CustomButton
                :outlined="true"
                size="medium"
                :shadow="false"
                class="py-2 px-4 hover:!bg-primary-violet hover:!border-none"
                @click="router.push('/destinations')"
            >
              SEE DESTINATIONS
            </CustomButton>
          </div>
      </div>

    </div>

  </div>


</template>


